/**
 * Rueckkehr aus dem OAuth-Tanz. Unveraendert aus account-web uebernommen.
 *
 * Die Seite tut selbst nichts: core-api hat die Cookies bereits gesetzt, der
 * AuthProvider liest sie beim naechsten `/session` von allein. Sie ist der
 * Wartebildschirm dafuer — und der Ort, an dem ein Fehler sichtbar wird,
 * statt in einer weissen Seite zu enden.
 */

import { useAuth } from './AuthContext';

export function AuthCallbackPage() {
  const { error } = useAuth();

  if (error) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-gray-50">
        <div className="text-center p-8">
          <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-red-100 flex items-center justify-center">
            <svg className="w-8 h-8 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </div>
          <h1 className="text-2xl font-bold text-red-600 mb-2">Anmeldung fehlgeschlagen</h1>
          <p className="text-gray-600 mb-6">{error}</p>
          <a
            href="/login"
            className="inline-flex items-center justify-center px-6 py-3 rounded-lg bg-primary-600 text-white font-medium hover:bg-primary-700 transition-colors"
          >
            Zurueck zum Login
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50">
      <div className="text-center p-8">
        <div className="h-12 w-12 animate-spin rounded-full border-4 border-primary-600 border-t-transparent mx-auto mb-4"></div>
        <p className="text-gray-600">Anmeldung wird verarbeitet...</p>
      </div>
    </div>
  );
}
